import { useEffect } from 'react';
import {
  attachForegroundWebPushHandler,
  ensureWebPushRegistration,
} from '../../services/webPush/firebaseWebPush';

function WebPushBootstrap() {
  const token = localStorage.getItem('token');

  useEffect(() => {
    if (!token) {
      return;
    }

    const bootstrap = async () => {
      try {
        await ensureWebPushRegistration({ requestPermission: true });
        await attachForegroundWebPushHandler();
      } catch (error) {
        console.warn('[WebPushBootstrap] Failed to initialize web push:', error);
      }
    };

    bootstrap();

  }, [token]);

  return null;
}

export default WebPushBootstrap;
